import { Link, navigate, useNavigate } from 'react-router-dom';
import { Offcanvas, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import StatusBlock from '../StatusBlock/StatusBlock';

// import { openNewTabWithChecklist } from '../Functions';
import { linkOESDGSE, linkDPImprint, default_tooltip_hide, default_tooltip_show } from '../Consts';

import './Navigation.css';

const packageJson = require('../../../package.json');

const Navigation = ({ parentState, backCallerHandleToggleOffCanvas, backCallerHandlePrint, callbackHandleSave,
    callbackHandleFileLoadChange, callbackHandleSaveCSV, backCallerHandleWIPModal, callbackHandleFixStateDataFromGridFromApp
}) => {

    const navigate = useNavigate();

    function handleHide() {
        backCallerHandleToggleOffCanvas();
        var wrapper = document.querySelector('.move-right');
        var toggleIconDiv = document.getElementById('toggle-icon-div');
        wrapper.classList.remove('offcanvas-open');
        setTimeout(function () {
            toggleIconDiv.classList.remove('oc-open');
            toggleIconDiv.classList.add('oc-close');
        }, 50);
    }

    const handleUploadButtonClick = () => {
        document.getElementById('inputFileUpload').click();
    };

    const handleUploadLabelClick = (e) => {
        e.stopPropagation();
    };

    const handleNavigateToEval = () => {
        callbackHandleFixStateDataFromGridFromApp();
        navigate('/erfassung/auswertung');
    }

    const openWindowNewSite = (site) => {
        if (site === 'dgse') {
            window.open(linkOESDGSE, '_blank');
        }
        if (site === 'imprint') {
            window.open(linkDPImprint + "imprint", '_blank');
        }
        if (site === 'dp') {
            window.open(linkDPImprint + "dp", '_blank');
        }
    }

    return (
        <Offcanvas className="mt-5" backdrop={false} show={parentState.helper.offcanvas.show}
            scroll={true} placement="start" id="offcanvasNavbar">
            <Offcanvas.Body className="pt-0 mt-0 bg-light">
                <div id="dgse-nav-container" className="flex-shrink-0 p-3 pb-0 bg-white">
                    <div className="d-flex w-100">
                        <span className="fs-5 fw-semibold border-bottom w-100">Navigation</span>
                        <i className="fw-bold bi bi-chevron-double-left pe-2" onClick={handleHide} aria-label="Close"></i>
                    </div>
                    <ul className="list-unstyled pt-0 m-0">
                        <li className="mb-1 my-3">
                            <a href="/" className="">
                                <Button className="btn btn-toggle align-items-center rounded collapsed border-0 icon-back">
                                    Zurück zur Tool-Auswahl
                                </Button>
                            </a>
                        </li>
                        <li className="border-top my-3"></li>

                        <li className="mb-1 my-3">
                            <Link to="/erfassung">
                                <OverlayTrigger
                                    placement="right"
                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                    overlay={<Tooltip className="navigation-tooltip"
                                        id="tooltipNavTable">Zur Noteneingabe wechseln.</Tooltip>
                                    }
                                    show={parentState.helper.tooltips ? undefined : false}
                                >
                                    <Button
                                        className="btn btn-toggle align-items-center rounded collapsed border-0">
                                        Klassenarbeit erfassen
                                    </Button>
                                </OverlayTrigger>
                            </Link>
                        </li>

                        <li className="mb-1 my-3">
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip"
                                    id="tooltipNavEval">Die Auswertung der Klassenarbeit starten.</Tooltip>
                                }
                                show={parentState.helper.tooltips ? undefined : false}
                            >
                                <Button
                                    onClick={() => handleNavigateToEval()}
                                    className="btn btn-toggle align-items-center rounded collapsed border-0">
                                    Klassenarbeit auswerten
                                </Button>
                            </OverlayTrigger>
                        </li>

                        <li className="mb-1 my-3">
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip"
                                    id="tooltipNavTable">Eine Klassenarbeit lokal speichern.</Tooltip>
                                }
                                show={parentState.helper.tooltips ? undefined : false}
                            >
                                <Button
                                    onClick={((e) => callbackHandleSave(e))}
                                    className="btn btn-toggle align-items-center rounded collapsed border-0">
                                    Klassenarbeit lokal speichern
                                </Button>
                            </OverlayTrigger>
                        </li>

                        <li className="mb-1 my-3">
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip"
                                    id="tooltipNavPrint">Die Notenliste drucken.</Tooltip>
                                }
                                show={parentState.helper.tooltips ? undefined : false}
                            >
                                <Button
                                    onClick={() => backCallerHandlePrint()}
                                    className="btn btn-toggle align-items-center rounded collapsed border-0">
                                    Notenliste drucken
                                </Button>
                            </OverlayTrigger>
                        </li>

                        <li className="mb-1 my-3">
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip"
                                    id="tooltipNavTable">Eine lokal gespeicherte Klassenarbeit laden. Sie können nur Klassenarbeiten öffnen, welche mit dem Examer bearbeitet wurden.</Tooltip>
                                }
                                show={parentState.helper.tooltips ? undefined : false}
                            >
                                <Button
                                    onClick={handleUploadButtonClick}
                                    className="btn btn-toggle align-items-center rounded collapsed border-0 button-hover-white">
                                    <label
                                        className="pointerFinger button-hover-white p-0"
                                        htmlFor="inputFileUpload"
                                        onClick={handleUploadLabelClick}
                                    >
                                        Klassenarbeit öffnen
                                        <input
                                            id="inputFileUpload"
                                            type="file"
                                            accept=".json,application/json"
                                            // onChange={e => this.handleFileSaveChange(e, this)}
                                            onChange={e => callbackHandleFileLoadChange(e)}
                                            style={{ display: 'none' }}
                                        />
                                    </label>
                                </Button>
                            </OverlayTrigger>
                        </li>

                        

                        <li className="mb-1 my-3">
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip"
                                    id="tooltipNavTable">Daten als CSV-Datei für Tabellenkalkulation exportieren.</Tooltip>
                                }
                                show={parentState.helper.tooltips ? undefined : false}
                            >
                                <Button
                                    onClick={() => callbackHandleSaveCSV()}
                                    className="btn btn-toggle align-items-center rounded collapsed border-0">
                                    Klassenarbeit für Excel exportieren
                                </Button>
                            </OverlayTrigger>
                        </li>

                        

                        <li className="border-top my-3"></li>
                        <li className="mb-1 my-3">
                            <OverlayTrigger placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip">Es öffnet sich ein neues Fenster mit Informationen zu Datengestützte Schul- und Unterrichtsentwicklung (DGSE).</Tooltip>
                                }
                                show={parentState.helper.tooltips ? undefined : false}
                            >
                                <Button className="btn btn-toggle align-items-center rounded collapsed border-0"
                                    onClick={() => openWindowNewSite('dgse')}>
                                    Handreichungen
                                </Button>
                            </OverlayTrigger>
                        </li>

                        <li className="border-top my-3"></li>
                        <li className="mb-1 my-3">
                            <OverlayTrigger placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip">Es öffnet sich ein neues Fenster mit der Datenschutzerklärung.</Tooltip>
                                }
                                show={parentState.helper.tooltips ? undefined : false}
                            >
                                <Button className="btn btn-toggle align-items-center rounded collapsed border-0"
                                    onClick={() => openWindowNewSite('dp')}>
                                    Datenschutzerklärung
                                </Button>
                            </OverlayTrigger>
                        </li>

                        <li className="mb-1 my-3">
                            <OverlayTrigger placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip">Es öffnet sich ein neues Fenster mit dem Impressum.</Tooltip>
                                }
                                show={parentState.helper.tooltips ? undefined : false}
                            >
                                <Button className="btn btn-toggle align-items-center rounded collapsed border-0"
                                    onClick={() => openWindowNewSite('imprint')}>
                                    Impressum
                                </Button>
                            </OverlayTrigger>
                        </li>


                        {/* <li className="mb-1 my-3">
                            <Button className="btn btn-toggle align-items-center rounded collapsed border-0"
                                onClick={() => backCallerHandleWIPModal()}>
                                Video Tutorial
                            </Button>
                        </li> */}

                        {2 > 0 && (
                            <>
                                <li className="border-top my-3"></li>
                                {/* <li className="mb-3 my-3 ps-1"> */}
                                <li className="my-4">

                                    <StatusBlock parentState={parentState} />

                                </li>
                            </>
                        )}


                    </ul>
                </div>

                <div
                    className="position-fixed bottom-0 start-0 m-2 px-2 bg-dark text-white opacity-75 rounded"
                    style={{ fontSize: '12px', width: 'auto', textAlign: 'right' }}
                >
                    Version: {packageJson.version}
                </div>

            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default Navigation; 